export const ignoreErrors = [
  'Cannot set property tron of #<Window> which has only a getter',
  /tron/i,
  /chrome-extension/i,
  /ResizeObserver loop limit exceeded/i,
  /moz-extension/i,
  /metamask/i,
]
